import { inject, Injectable } from "@angular/core";
import { WebBooking } from "./models/event-bookings/web-booking.model";
import { Observable } from "rxjs";
import { EventBookingComplete } from "./models/event-bookings/event-booking-complete.model";
import { PaypalResponse } from "./models/payments/paypal-response.model";
import { ApiWrapperService } from "ngx-apiwrapper";

@Injectable({
    providedIn: 'root'
})
export class EventBookingService {
    private readonly _apiWrapper = inject(ApiWrapperService);

    createEventBooking(booking: WebBooking) : Observable<EventBookingComplete> {
        return this._apiWrapper.post<EventBookingComplete>('booking', booking)
    }

    processPaypalPayment(paypalResponse: PaypalResponse): Observable<void>{
        return this._apiWrapper.post('booking/payments/paypal',paypalResponse);
    }
}